import {
  Box,
  Button,
  Link,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useProvider, useWaitForTransaction } from "wagmi";

import { ProcessingModal } from "../ProcessingModal";
import analyticsInstance from "../../config/analytics";
import { NUM_CONFIRMATIONS } from "../../config/constants";
import { useSupportedNetwork } from "../../helpers/hooks/network";
import { approveSubscription, getClaims } from "../../helpers/streams";

function Subscriptions({ account, hideTitle, hideDescription }) {
  const [subscriptions, setSubscriptions] = useState();
  const [tx, setTx] = useState();

  const provider = useProvider();
  const { isSupportedNetwork, chain } = useSupportedNetwork();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { status } = useWaitForTransaction({ hash: tx?.hash, confirmations: NUM_CONFIRMATIONS });

  useEffect(() => {
    if (!isSupportedNetwork || !chain || status === "loading" || status === "error") return;

    setSubscriptions(null);
    getClaims(provider, chain.id, account)
      .then((subs) => {
        let existingSubs = subs.filter((s) => s.exist);
        setSubscriptions(existingSubs);
      })
      .catch((e) => {
        // TODO: error handling
        console.log("error fetching subscriptions", e);
        analyticsInstance.track("SubscriptionsGetError", {
          account: account,
          error: e,
        });
      });
  }, [account, chain, isSupportedNetwork, provider, status]);

  return (
    <Box py="2em">
      {!hideTitle && (
        <Text fontSize="xl" fontWeight="bold" mb="0.5em">
          🪂 Subscriptions
        </Text>
      )}

      {subscriptions ? (
        <>
          {subscriptions.length > 0 ? (
            <>
              {!hideDescription && (
                <Box mt="1em" mb="2em">
                  <Text>In order to get your moneyz, you have to approve the distributions 👇🏻.</Text>
                  <Link href="/faq#subscriptions" isExternal>
                    What does that mean? Check the FAQ.
                  </Link>
                </Box>
              )}

              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>pair</Th>
                      {/* <Th>shares</Th> */}
                      {/* TODO: replace this with "distributed" or something else */}
                      {/* <Th>to be distributed</Th> */}
                      <Th>actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {subscriptions.map((s, idx) => {
                      return (
                        <Tr key={idx}>
                          <Td>
                            {/* TODO: link to the superfluid console */}
                            {s.sourceToken}/{s.targetToken}
                          </Td>
                          {/* <Td isNumeric>TODO: use s.units with getIndex's totalUnitsApproved/Pending</Td> */}
                          <Td>
                            {!s.approved ? (
                              <>
                                <Button
                                  size="xs"
                                  colorScheme="teal"
                                  onClick={() => {
                                    onOpen();
                                    setTx(null);
                                    approveSubscription(
                                      provider,
                                      chain.id,
                                      s.pairContractAddress,
                                      s.targetToken,
                                      s.indexId
                                    )
                                      .then((result) => {
                                        console.log("RESULT!");
                                        console.log(result);
                                        setTx(result);
                                      })
                                      .catch((err) => {
                                        // TODO: do something on error
                                        console.log("ERROR!");
                                        console.log(err);
                                        setTx({ txError: err });

                                        analyticsInstance.track("SubscriptionApprovalError", { error: err });
                                      });

                                    analyticsInstance.track("SubscriptionApprovalClicked");
                                  }}
                                >
                                  🤑 I want to get paid! 💰
                                </Button>
                                <ProcessingModal isOpen={isOpen} onClose={onClose} tx={tx} />
                              </>
                            ) : (
                              <Text fontSize="xs">Already approved!</Text>
                            )}
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </>
          ) : (
            // TODO: style
            <>
              <Text>Have you BTFDCA'ed? Doesn't seem like it, cause we can't find any stream.</Text>
              <Text>
                {/* TODO: review copy */}
                If you think something's wrong here, please reach out (and check the Superfluid dashboard 👇🏻 for more
                details).
              </Text>
            </>
          )}
        </>
      ) : (
        <>
          <Spinner />
        </>
      )}
    </Box>
  );
}

export default Subscriptions;
